import React, { Component } from "react";
import { Badge, Row, Col, Dropdown } from "react-bootstrap";
import "moment/locale/es-do";
import { FormattedTime } from "react-intl";
import IntlMessages from "../../helpers/IntlMessages";
import SpeakerFlag from "../Speakers/SpeakerFlag";
import { connect } from "react-redux";
import "./style.css";
import { Button } from "react-bootstrap";
import SessionVideoModal from "./SessionVideoModal";
import { SessionChildActivities } from "./SessionChildActivities";
import SpeakerItemInList from "../Speakers/SpeakerItemInList";
import Utils from "../Utils";
import Storage from "../Storage";
import { withRouter } from "react-router-dom";
import axios from "axios";
import { __APIKCURL_V3__ } from "../../consts/consts";
import SessionsDescriptionOnline from "./SessionsDescriptionOnline";

class SessionByDay extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dayActs: [],
      showModal: false,
      urlModal: "",
      titleModal: "",
      childActsShowing: [],
    };
  }

  getActivitiesForTheDay() {
    const { actsArray, day, onlyNoParentActivities } = this.props;
    var moment = require("moment-timezone");

    var actsFilteredByDay = actsArray
      .filter(function (activity) {
        return moment(activity.startDateTime).isSame(day, "day");
      })
      .sort((a, b) => a.startDateTime.localeCompare(b.startDateTime)  ||  a.order.localeCompare(b.order))  ;

    if (onlyNoParentActivities) {
      actsFilteredByDay = actsFilteredByDay.filter(
        (act) => act.idParentActivity == 0
      );
    }

    return actsFilteredByDay;
  }

  getActivityTitle(activity) {
    switch (this.props.locale) {
      case "en":
        return activity.title_EN !== "" ? activity.title_EN : activity.title;
      case "es":
        return activity.title_ES !== "" ? activity.title_ES : activity.title;
      case "pt":
        return activity.title_PT !== "" ? activity.title_PT : activity.title;
      case "fr":
        return activity.title_FR !== "" ? activity.title_FR : activity.title;
      default:
        return activity.title;
    }
  }
  getActivityDescription(activity) {
    switch (this.props.locale) {
      case "en":
        return activity.description_EN !== ""
          ? activity.description_EN
          : activity.description;
      case "es":
        return activity.description_ES !== ""
          ? activity.description_ES
          : activity.description;
      case "pt":
        return activity.description_PT !== ""
          ? activity.description_PT
          : activity.description;
      case "fr":
        return activity.description_FR !== ""
          ? activity.description_FR
          : activity.description;
      default:
        return activity.title;
    }
  }

  _getActivitySpeakers(activity) {
    const { speakers } = this.props;
    //gec: Importante! si es undefined es porque estamos renderizando las actividades del Speaker
    if (speakers !== undefined) {
      var actSpks = speakers.filter((spk) =>
        activity.speakerIds.includes(parseInt(spk.id))
      );
      actSpks = actSpks.map(speaker => {
        const orderInActivity = activity.speakerActivity.find(item => item.idSpeaker === parseInt(speaker.id))?.speakerOrder
        speaker.speakerOrder = orderInActivity
        return speaker
      })
      return actSpks.length == 0
        ? null
        : actSpks
          .sort((a, b) => a.speakerOrder - b.speakerOrder)
          .map((speaker) => (
            <li className="speaker-card-wrapper">
              <SpeakerItemInList
                speaker={speaker}
                role={
                  speaker.speakerActivity.find(
                    (spa) => spa.idActivity == activity.id
                  ).speakerRole
                }
              />
            </li>
          ));
    }
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }

  getActivityAllAuthorText(activity) {
    return activity.allAuthorListText;
  }

  getActivityVideoLinkForModal(activity) {
    switch (this.props.locale) {
      case "en":
        return activity.videoLink_EN; //!= null ? activity.videoLink_EN : null;
      case "es":
        return activity.videoLink_ES; //!= null ? activity.videoLink_ES : null;
      case "pt":
        return activity.videoLink_PT; //!= null ? activity.videoLink_PT : null;
      case "fr":
        return activity.videoLink_FR; //!= null ? activity.videoLink_FR : null;
      default:
        return activity.videoLink;
    }
  }

  getActivityTrack(activity) {
    const { actTracks } = this.props;
    const idTrack = activity.idActivityTrack;
    if (idTrack == 0) {
      return "";
    }
    const track = actTracks.find((track) => track.id == idTrack);
    let trackName = "";
    switch (this.props.locale) {
      case "en":
        trackName = track.name_EN;
        break;
      case "es":
        trackName = track.name_ES;
        break;
      case "pt":
        trackName = track.name_PT;
        break;
      case "fr":
        trackName = track.name_FR;
        break;
      default:
        trackName = track.name;
        break;
    }
    return { track: trackName, color: track.color };
  }

  getActivityType(activity) {
    const { actTypes } = this.props;
    const idType = activity.idActivityType;

    if (idType == 0) {
      return "";
    }

    const type = actTypes.find((type) => type.id == idType);
    let typeName = "";
    switch (this.props.locale) {
      case "en":
        if (type.name_EN) typeName = type.name_EN;
        break;
      case "es":
        if (type.name_ES) typeName = type.name_ES;
        break;
      case "pt":
        if (type.name_PT) typeName = type.name_PT;
        break;
      case "fr":
        if (type.name_FR) typeName = type.name_FR;
        break;
      default:
        typeName = type.name;
    }
    return { type: typeName, color: type.color };
  }

  openModal(activity, mode) {
    var url = "";
    switch (mode) {
      case "video":
        url = activity;
        break;
      case "file":
        url = Utils.getFileHandlerUrl(activity.idEventFile);
    }

    if (url != null) {
      this.setState({
        showModal: true,
        urlModal: url,
        modalMode: mode,
        titleModal: this.getActivityTitle(activity),
      });
    }
  }

  executeAction(activity, liveWasClicked) {
    //var tableHeight = document.getElementById(activity.id).parentElement.offsetHeight
    // var elementTop = document.getElementById(activity.id).getBoundingClientRect().top
    var topHeight =
      document.getElementById(activity.id).getBoundingClientRect().top -
      115 +
      window.scrollY;

    // if (tableHeight - elementTop - window.scrollY <= 200){
    //     topHeight = document.getElementById(activity.id).getBoundingClientRect().top - 120 - window.scrollY;
    // }

    if (liveWasClicked)
      var roomLink = this.getActivityVideoLinkForModal(
        Storage.getRoomsInfo().find(
          (room) => room.id == activity.idActivityRoom
        )
      );

    this.props.clickAction(activity, topHeight, roomLink);
  }

  handleChildActivities(activity) {
    var actIdx = this.state.childActsShowing.indexOf(activity.id);
    var newChildActs = [];

    if (actIdx >= 0) {
      this.state.childActsShowing.splice(actIdx, 1);
    } else {
      this.state.childActsShowing.push(activity.id);
    }

    newChildActs = newChildActs.concat(this.state.childActsShowing);

    this.setState({ childActsShowing: newChildActs });
  }

  goToRoom(ev) {
    const roomId = ev.currentTarget.attributes.roomId.value;
    this.props.history.push({ pathname: "/liveStream/" + roomId });
    //window.open("/liveStream/liveStreamView?roomId="+roomId ,"_self");
  }

  getCalendarForGoogleCalendar(id) {
    const activityId = id;
    axios
      .get(`${__APIKCURL_V3__}calendar/activity/${activityId}/google`)
      .then((response) => {
        const url = response.data;
        window.open(encodeURI(url));
      });
  }
  getCalendarForOutlook(id) {
    const activityId = id;
    window.open(
      `${__APIKCURL_V3__}calendar/activity/${activityId}/outlook`,
      "_self"
    );
  }

  render() {
    var moment = require("moment-timezone");
    let tz = Storage.getTimeZone();
    let zone = moment.tz.zone(tz);

    const { spkId } = this.props;

    var dayActs = this.getActivitiesForTheDay();
    const regex = /(<([^>]+)>)/gi;

    return dayActs.length !== 0 ? (
      <div id="SessionsByDay">
        <table role="table" className="r-table table table-divided">
          <tbody role="rowgroup">
            {dayActs.map((activity) => (
              <>
                <tr
                  role="row"
                  key={activity.id + activity.title}
                  id={activity.id}
                  onClick={() => this.executeAction(activity)}
                >
                  <td
                    role="cell"
                    className="list-item-heading"
                    style={{
                      backgroundColor: this.getActivityType(activity).color,
                    }}
                  ></td>
                  <td role="cell" className="list-item-heading w-95">
                    <div className="list-item-time-row ">
                      <Badge
                        pill
                        variant="secondary"
                        className="session-time-pill"
                      >
                        <i className="simple-icon-clock"></i>{" "}
                        <FormattedTime
                          value={activity.startDateTime}
                          hour="numeric"
                          minute="numeric"
                        />{" "}
                        {" - "}
                        <FormattedTime
                          value={activity.endDateTime}
                          hour="numeric"
                          minute="numeric"
                        />
                      </Badge>
                      {/* {Utils.renderIf(activity.idActivityRoom != null && activity.idActivityRoom != '',
                                            <Button variant="outline-primary" roomId={activity.idActivityRoom}onClick={(ev)=>this.goToRoom(ev)}>
                                                <i className="simple-icon-location-pin"/>
                                                <IntlMessages id="dashboards.goToRoom"/>  
                                            </Button>
                                        )} */}
                      <Dropdown className="sessions-add-to-calendar">
                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                          <i class="simple-icon-event"></i>{" "}
                          <IntlMessages id="dashboards.addEventToCalendar" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() =>
                              this.getCalendarForGoogleCalendar(activity.id)
                            }
                          >
                            Google Calendar
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() =>
                              this.getCalendarForOutlook(activity.id)
                            }
                          >
                            Outlook/Apple
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <div
                      class="list-item-heading mb-1 sessionTitle"
                      dangerouslySetInnerHTML={{
                        __html: this.getActivityTitle(activity),
                      }}
                    />
                    {this.getActivityDescription(activity).match("(TS)") !=
                      null ? (
                      <div>
                        <i className="iconsminds-headphones" />
                        <i className="simple-icon-flag" />
                      </div>
                    ) : null}
                    <div
                      class="sessionDescription"
                      dangerouslySetInnerHTML={{
                        __html: this.getActivityDescription(activity),
                      }}
                    />
                    {
                      Boolean(activity.descriptionOnline) && <SessionsDescriptionOnline activity={activity} />
                    }
                    {this.getActivityTrack(activity) ? (
                      <p class="mb-0 sessionTrack">
                        <i className="simple-icon-tag"></i>{" "}
                        {this.getActivityTrack(activity).track}
                      </p>
                    ) : null}
                    {this.getActivityType(activity) ? (
                      <p class="mb-0 sessionType">
                        <i className="simple-icon-graduation"></i>{" "}
                        {this.getActivityType(activity).type}
                      </p>
                    ) : null}
                    {activity.room ? (
                      <p
                        class="mb-0 sessionRoom"
                        roomId={activity.idActivityRoom}
                        onClick={(ev) => this.goToRoom(ev)}
                      >
                        <i className="simple-icon-location-pin"></i>{" "}
                        {activity.room}
                      </p>
                    ) : null}
                    <p
                      dangerouslySetInnerHTML={{
                        __html: this.getActivityAllAuthorText(activity),
                      }}
                    />
                    <ul className="speaker-cards-container">{this._getActivitySpeakers(activity)}</ul>
                    {moment.tz(new Date(), tz) >=
                      moment.tz(activity.startDateTime, tz) &&
                      moment.tz(new Date(), tz) <=
                      moment.tz(activity.endDateTime, tz) ? (
                      <Button
                        onClick={() => this.executeAction(activity, true)}
                        variant="outline-danger"
                        className="divActsBadge"
                      >
                        <i class="iconsminds-youtube"></i>
                        <IntlMessages id="dashboards.liveRoom" />
                      </Button>
                    ) : null}{" "}
                    {/* { this.getActivityVideoLinkForModal(activity) != null && this.getActivityVideoLinkForModal(activity) != ''?
                                            <Button onClick= {() => this.openModal(activity,"video")} className="divActsBadge"  variant="outline-success"><i class="iconsminds-video"></i><IntlMessages id="dashboards.seeModal"/>
                                            </Button>         
                                        : 
                                        null
                                    } {' '} */}
                    {activity.childActivitiesIds.length == 0 ||
                      spkId != undefined ? null : (
                      <div
                        onClick={() => this.handleChildActivities(activity)}
                        className="div-activities-button"
                      >
                        {this.state.childActsShowing.includes(activity.id) ? (
                          <div className="show-child-activities-wrapper">
                            <IntlMessages id="dashboards.hideChildActs" />
                            <i className="simple-icon-arrow-up"></i>
                          </div>
                        ) : (
                          <div className="hidden-child-activities-wrapper">
                            <IntlMessages id="dashboards.seeChildActs" />
                            <i className="simple-icon-arrow-down"></i>
                          </div>
                        )}
                      </div>
                    )}{" "}
                    {activity.videoLink_ES != null &&
                      activity.videoLink_ES != "" ? (
                      <Button
                        onClick={() =>
                          this.openModal(activity.videoLink_ES, "video")
                        }
                        className="divActsBadge"
                        variant="outline-success"
                      >
                        <i class="iconsminds-video"></i>
                        <IntlMessages id="dashboards.seeModal" />{" "}
                        <SpeakerFlag
                          class="videoLinkFlag"
                          countryName={"Spain"}
                        />
                      </Button>
                    ) : null}{" "}
                    {activity.videoLink_EN != null &&
                      activity.videoLink_EN != "" ? (
                      <Button
                        onClick={() =>
                          this.openModal(activity.videoLink_EN, "video")
                        }
                        className="divActsBadge"
                        variant="outline-success"
                      >
                        <i class="iconsminds-video"></i>
                        <IntlMessages id="dashboards.seeModal" />{" "}
                        <SpeakerFlag
                          class="videoLinkFlag"
                          countryName={"ReinoUnido"}
                        />
                      </Button>
                    ) : null}{" "}
                    {activity.videoLink_PT != null &&
                      activity.videoLink_PT != "" ? (
                      <Button
                        onClick={() =>
                          this.openModal(activity.videoLink_PT, "video")
                        }
                        className="divActsBadge"
                        variant="outline-success"
                      >
                        <i class="iconsminds-video"></i>
                        <IntlMessages id="dashboards.seeModal" />{" "}
                        <SpeakerFlag
                          class="videoLinkFlag"
                          countryName={"Portugal"}
                        />
                      </Button>
                    ) : null}{" "}
                    {activity.videoLink_FR != null &&
                      activity.videoLink_FR != "" ? (
                      <Button
                        onClick={() =>
                          this.openModal(activity.videoLink_FR, "video")
                        }
                        className="divActsBadge"
                        variant="outline-success"
                      >
                        <i class="iconsminds-video"></i>
                        <IntlMessages id="dashboards.seeModal" />{" "}
                        <SpeakerFlag
                          class="videoLinkFlag"
                          countryName={"France"}
                        />
                      </Button>
                    ) : null}{" "}
                    {activity.idEventFile != null &&
                      activity.idEventFile != "" ? (
                      <Button
                        onClick={() => this.openModal(activity, "file")}
                        variant="outline-info"
                      >
                        <i class="iconsminds-blackboard"></i>
                        <IntlMessages id="dashboards.openModalPresentation" />
                      </Button>
                    ) : null}{" "}
                    {this.state.childActsShowing.find(
                      (id) => id == activity.id
                    ) != null ? (
                      <SessionChildActivities
                        childActs={this.props.actsArray.filter((act) =>
                          activity.childActivitiesIds.includes(parseInt(act.id))
                        )}
                        actTypes={this.props.actTypes}
                        actTracks={this.props.actTracks}
                        speakers={this.props.speakers}
                        getVideoLinkForModal={(activity) =>
                          this.getActivityVideoLinkForModal(activity)
                        }
                        openModal={(activity) =>
                          this.openModal(activity, "video")
                        }
                      />
                    ) : null}
                  </td>
                </tr>
              </>
            ))}
          </tbody>
        </table>
        <SessionVideoModal
          show={this.state.showModal}
          mode={this.state.modalMode}
          url={this.state.urlModal}
          title={this.state.titleModal}
          closeModalHandler={() => this.closeModal()}
        />
      </div>
    ) : (
      <Row className="sessionFirstRow justify-content-md-center">
        <Col>
          <div className="rb-spinner">
            <h2>
              <IntlMessages id="dashboards.noActsToShow" />
            </h2>
          </div>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => {
  return { locale: state.settings.locale };
};

export default connect(mapStateToProps, null)(withRouter(SessionByDay));
